/**
 * @generated SignedSource<<c192b1c6e09087e401b7fe208253c92b>>
 * @relayHash 50a05a1763af2fa0e359d5a80bc515ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c13fe53da769ce7961b5da0446355ed457608570787aafd119adee16e3bc2ad

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdates405BadPatternSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdates405BadPatternSubscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdates405BadPatternSubscription = {
  response: IssueRealtimeUpdates405BadPatternSubscription$data;
  variables: IssueRealtimeUpdates405BadPatternSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdates405BadPatternSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdates405BadPatternSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "4c13fe53da769ce7961b5da0446355ed457608570787aafd119adee16e3bc2ad",
    "metadata": {},
    "name": "IssueRealtimeUpdates405BadPatternSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "593f955b8458d4061b00b37a2dbd4219";

export default node;
